export interface StaticLayerCache<T> {
  ensure: (key: string, factory: () => T) => T;
  invalidate: () => void;
  getBuildCount: () => number;
}

export const createStaticLayerCache = <T>(): StaticLayerCache<T> => {
  let currentKey: string | null = null;
  let currentLayer: T | null = null;
  let buildCount = 0;

  return {
    ensure(key, factory) {
      if (currentLayer === null || currentKey !== key) {
        currentLayer = factory();
        currentKey = key;
        buildCount += 1;
      }
      return currentLayer;
    },
    invalidate() {
      currentKey = null;
      currentLayer = null;
    },
    getBuildCount() {
      return buildCount;
    },
  };
};
